import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import Header from '../Component/Header'
import Footer from '../Component/Footer'
const AboutUs = () => {
    useEffect(() => {
        document.title = 'About Us - Jai Rani Public School, Balussery';
    }, []);
    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li>About </li>
                    <li>About Us</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1>About Us</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p>Jai Rani SABS Public School is a Catholic Institution established and managed by Sisters of the Adoration of the Blessed Sacrament (SABS) of Thamarassery Province. This congregation was founded in 1908 by the Servant of God Bishop Thomas Kurialassery. Besides being a great devotee of the Eucharistic Lord, he was a great educationalist and reformer of the society. We pursue the spirit and Charisma of our founder in imparting progressive and quality education suited to the changing needs and aspirations of our country.</p>
                            <p>It is a co-educational institution affiliated to the Central Board of Secondary Education (CBSE) New Delhi and follows the text books and guidelines of the National Council of Educational Research and Training (NCERT).</p>
                            <p>Jai Rani is far and wide renowned as an institution of unparalleled academic standards and exceptional co-curricular training. The school has a friendly and outstanding faculty to bring up the youth buds of future generation. We provide our young people with challenging and inspiring learning opportunities that facilitate each of them to grow in confidence and develop attitudes and skills towards the challenges they face in today's world. We are proud of promoting faith in God and traditional values such as honesty, respect and politeness, as well as enjoying the latest technology, teaching methods and resources. Above all, we want our children to be happy, have confidence and possess a real enthusiasm for life.</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AboutUs;
